
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDIHsuSfuu9BLSN4W6qVXgkWqsYFDfySIE",
  authDomain: "mohamed-n-portfolio.firebaseapp.com",
  projectId: "mohamed-n-portfolio",
  storageBucket: "mohamed-n-portfolio.appspot.com",
  messagingSenderId: "31477770608",
  appId: "1:31477770608:web:61e2c397253e29e66547b5",
  measurementId: "G-Z3XE7QT9JG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
